import { useSiteStatus } from "./App";
// Mirrors the backend's src/loyalty/pulse/points.ts - the signup and first-consult amounts come
// from site_status/pulse_rewards_points so promos can be switched without a deploy, and a
// missing or invalid field falls back to its default. Keep the two in sync. Standard consults
// earn their med's own xtra.pulse_eligible amount.
const DEFAULT_PULSE_REWARDS_POINTS = { signup: 500, first_consult: 500 };
const MAX_POINTS = 5000;
// a valid points amount, or undefined
export const readPoints = (value) => typeof value === "number" && Number.isInteger(value) && value > 0 && value <= MAX_POINTS ? value : undefined;
export function usePulseRewardsPoints() {
    var _a, _b, _c;
    const config = (_a = useSiteStatus()) === null || _a === void 0 ? void 0 : _a.pulse_rewards_points;
    return {
        signup: (_b = readPoints(config === null || config === void 0 ? void 0 : config.signup)) !== null && _b !== void 0 ? _b : DEFAULT_PULSE_REWARDS_POINTS.signup,
        first_consult: (_c = readPoints(config === null || config === void 0 ? void 0 : config.first_consult)) !== null && _c !== void 0 ? _c : DEFAULT_PULSE_REWARDS_POINTS.first_consult,
    };
}
